export const answerReviewsPath = () => "/answer-reviews";
export const answerReviewSwipePath = () => "/answer-reviews/swipe";
export const answerReviewShowPath = (review) => `/answer-reviews/${review.id}`;
